import { useEffect, useState } from "react"
import AnalyticsData from "./components/AnalyticsData"
import Exported from "../../service/endpoints"
import request from "../../service"
import classes from "./style.module.scss";
import { Toast } from "../../service/toast";
import RedeemedFirstTimeList from "./components/RedeemedFirstTime";
import { useLocation } from "react-router-dom";
import FirstTimeQRScannedList from "./components/FirstTimeQRScanned";
import RepeatedQRScannedList from "./components/RepeatedQRScanned";
import FailedQRList from "./components/FailedQRList";
import TotalQRScanListByActiveUsers from "./components/TotalQRScans";
import TotalQRScanListByDeletedUsers from "./components/TotalQRScansByDeletedUsers";

const AppAnalytics = () => {
    const ACTIVE_USERS = 'Active Users'
    const INACTIVE_USERS = 'Inactive/Deleted Users'
    const [analyticsData, setAnalyticsData] = useState({})
    const [selectedMetric, setSelectedMetric] = useState(null)
    const [page, setPage] = useState(1);
    const [isLoading, setisLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState(null);
    const [metricList, setMetricList] = useState({});
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false)
    const location = useLocation();
    const LISTTYPE = [ACTIVE_USERS, INACTIVE_USERS,];
    const [activeTab, setActiveTab] = useState(ACTIVE_USERS)

    const deletedUsers = () => {
        if (activeTab === ACTIVE_USERS && selectedMetric !== "totalQRScansByActiveusers" && selectedMetric !== "totalQRScanByDeletedUsers") {
            return false
        } else if (selectedMetric === "totalQRScansByActiveusers") {
            return false
        } else if (selectedMetric === "totalQRScanByDeletedUsers") {
            return true
        } else {
            return true
        }
    }

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const metric = params.get("metric");
        setSelectedMetric(metric || null);
        setPage(1);
        setActiveTab(ACTIVE_USERS)
    }, [location.search]);

    useEffect(() => {
        getAnalyticsData()
    }, [])

    const getAnalyticsData = () => {
        let url = `${Exported.Endpoints.getAdminAnalytics}`
        request({
            url: url,
            method: Exported.APIMethods.GET,
        }).then((res) => {
            if (res?.data?.data) {
                const response = res?.data?.data
                let countObj = {
                    failedQRScansCount: response?.failedQRScansCount,
                    firstQrScanned: response?.firstQrScanned,
                    repeatScannedUsers: response?.repeatScannedUsers,
                    rewardRedeemedFirstTime: response?.reward_redeemed_first_time,
                    scanToRedeemRatio: response?.scan_to_redeem_ratio,
                    totalScanedPoints: response?.totalScanedPoints,
                    totalScans: response?.totalScans,
                    totalMechanicPoints: response?.total_mechanic_points,
                    totalRetailerPoints: response?.total_retailer_points,
                    totalMechanicScannedPoints: response?.totalMechanicScannedPoints,
                    totalRetailerScannedPoints: response?.totalRetailerScannedPoints,
                    totalScansByDeletedUsers: response?.totalScansByDeletedUsers,
                    totalScanedPointsByDeletedUser: response?.totalScanedPointsByDeletedUser,
                    totalMechanicScannedPointsByDeletedUser: response?.totalMechanicScannedPointsByDeletedUser,
                    totalRetailerScannedPointsByDeletedUser: response?.totalRetailerScannedPointsByDeletedUser
                }
                setAnalyticsData(countObj)
            } else {
                setAnalyticsData({})
            }
        }).catch((err) => {
            console.log(err, "err")
        })
    }

    useEffect(() => {
        if (!selectedMetric) return;

        const getIndividualMetricList = async (metric) => {
            setisLoading(true);
            let url = `${Exported.Endpoints[metric]}`;
            let paramsObj = {
                page: page,
                limit: 10,
                deleted_user: deletedUsers()
            };

            if (sortConfig) {
                paramsObj["sort"] = sortConfig?.key;
                paramsObj["sortOrder"] = sortConfig?.direction;
            }

            await request({
                url: url,
                params: { ...paramsObj },
                method: Exported.APIMethods.GET,
            })
                .then((res) => {
                    if (res?.data?.status) {
                        const obj = {
                            result: res?.data?.data?.list || [],
                            pageMeta: res?.data?.data?.pageMeta || {},
                        };
                        setMetricList(obj);
                    }
                })
                .catch((err) => {
                    Toast({
                        type: "error",
                        message: "Unable to process the request!..",
                    });
                });
            setisLoading(false);
        };

        const fetchData = async () => {
            let response;
            switch (selectedMetric) {
                case "rewardRedeemedFirstTime":
                    response = await getIndividualMetricList(selectedMetric);
                    break;

                case "firstTimeQRScanned":
                    response = await getIndividualMetricList(selectedMetric)
                    break;

                case "repeatedQRScanned":
                    response = await getIndividualMetricList(selectedMetric)
                    break;

                case "failedQRScans":
                    response = await getIndividualMetricList(selectedMetric)
                    break;

                case "totalQRScansByActiveusers":
                    response = await getIndividualMetricList(selectedMetric)
                    break;

                case "totalQRScanByDeletedUsers":
                    response = await getIndividualMetricList(selectedMetric)
                    break;

                default:
                    response = [];
            }

        }

        fetchData();

    }, [selectedMetric, page, sortConfig, activeTab])

    useEffect(() => {
        if (!isGeneratingPdf || !selectedMetric) return;
        generatePdf(selectedMetric);

    }, [isGeneratingPdf])

    const generatePdf = async (metric) => {
        try {

            let url = `${Exported.Endpoints[metric]}`;
            let paramsObj = {
                page: page,
                limit: 10,
                download: true,
                deleted_user: deletedUsers()

            };


            await request({
                url: url,
                params: { ...paramsObj },
                method: Exported.APIMethods.GET,
                responseType: 'arraybuffer',
            }).then((res) => {
                if (res?.data) {
                    const blob = new Blob([res.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    const downloadUrl = window.URL.createObjectURL(blob);

                    // Create an anchor element and trigger download
                    const link = document.createElement('a');
                    link.href = downloadUrl;

                    // Name the file appropriately based on the tab
                    let fileName = `${metric}.xlsx`;

                    link.download = fileName;
                    link.click();

                    // Clean up
                    window.URL.revokeObjectURL(downloadUrl);

                    Toast({
                        type: 'success',
                        message: 'Report generated successfully!'
                    });
                }
            }).catch((err) => {
                console.log(err, "err");
                Toast({
                    type: 'error',
                    message: 'Failed to generate Report. Please try again.'
                });
            });
        } finally {
            setIsGeneratingPdf(false);
        }
    };

    return (
        <>
            {
                selectedMetric === "rewardRedeemedFirstTime" ?
                    <RedeemedFirstTimeList isLoading={isLoading} metricList={metricList} sortConfig={sortConfig} setSortConfig={setSortConfig} page={page} setPage={setPage} setIsGeneratingPdf={setIsGeneratingPdf} isGeneratingPdf={isGeneratingPdf} ListType={LISTTYPE} setActiveTab={setActiveTab} activeTab={activeTab} />
                    :
                    selectedMetric === "firstTimeQRScanned" ?
                        <FirstTimeQRScannedList isLoading={isLoading} metricList={metricList} sortConfig={sortConfig} setSortConfig={setSortConfig} page={page} setPage={setPage} setIsGeneratingPdf={setIsGeneratingPdf} isGeneratingPdf={isGeneratingPdf} ListType={LISTTYPE} setActiveTab={setActiveTab} activeTab={activeTab} />
                        :
                        selectedMetric === "repeatedQRScanned" ?
                            <RepeatedQRScannedList isLoading={isLoading} metricList={metricList} sortConfig={sortConfig} setSortConfig={setSortConfig} page={page} setPage={setPage} setIsGeneratingPdf={setIsGeneratingPdf} isGeneratingPdf={isGeneratingPdf} ListType={LISTTYPE} setActiveTab={setActiveTab} activeTab={activeTab} />
                            :
                            selectedMetric === "failedQRScans" ?
                                <FailedQRList isLoading={isLoading} metricList={metricList} sortConfig={sortConfig} setSortConfig={setSortConfig} page={page} setPage={setPage} setIsGeneratingPdf={setIsGeneratingPdf} isGeneratingPdf={isGeneratingPdf} ListType={LISTTYPE} setActiveTab={setActiveTab} activeTab={activeTab} />
                                :
                                selectedMetric === "totalQRScansByActiveusers" ?
                                    <TotalQRScanListByActiveUsers isLoading={isLoading} metricList={metricList} sortConfig={sortConfig} setSortConfig={setSortConfig} page={page} setPage={setPage} setIsGeneratingPdf={setIsGeneratingPdf} isGeneratingPdf={isGeneratingPdf} />
                                    :
                                    selectedMetric === "totalQRScanByDeletedUsers" ?
                                        <TotalQRScanListByDeletedUsers isLoading={isLoading} metricList={metricList} sortConfig={sortConfig} setSortConfig={setSortConfig} page={page} setPage={setPage} setIsGeneratingPdf={setIsGeneratingPdf} isGeneratingPdf={isGeneratingPdf} />
                                        :
                                        <div className={`${classes.dashboardWrapper}`}>
                                            <div className={`w-[100%] flex items-center justify-between`}>
                                                <div className={`layout-title`}>App Analytics</div>
                                            </div>
                                            <div>
                                                <AnalyticsData analyticsData={analyticsData} setSelectedMetric={setSelectedMetric} />
                                            </div>

                                        </div>
            }
        </>

    )
}

export default AppAnalytics